var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLinkedinDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2410_31682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.494 24.3987L24.5 24.3977V15.5957C24.5 11.2897 23.573 7.97266 18.539 7.97266C16.119 7.97266 14.495 9.30066 13.832 10.5597H13.762V8.37466H8.98901V24.3977H13.959V16.4637C13.959 14.3747 14.355 12.3547 16.942 12.3547C19.491 12.3547 19.529 14.7387 19.529 16.5977V24.3987H24.494Z",
    fill: "#E3E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.895996 8.375H5.872V24.398H0.895996V8.375Z",
    fill: "#E3E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.382 0.398438C1.791 0.398438 0.5 1.68944 0.5 3.28044C0.5 4.87144 1.791 6.18944 3.382 6.18944C4.973 6.18944 6.264 4.87144 6.264 3.28044C6.263 1.68944 4.972 0.398438 3.382 0.398438Z",
    fill: "#E3E9EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2410_31682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.398438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedinDark);
export default __webpack_public_path__ + "static/media/FooterLinkedinDark.f09c1b38d5e72ebb3e15320b3a637046.svg";
export { ForwardRef as ReactComponent };